import React, { useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Button, Col, FormLabel, FormGroup, Modal, Row } from 'react-bootstrap';

import MessagePreview from 'App/components/Sms/MessagePreview';
import useGetCustomMenuQuery from 'App/hooks/useGetCustomMenuQuery';
import { CheckboxInput } from 'Shared/form/CheckboxField';
import useCreateMesssagePreview from 'App/hooks/useCreateMesssagePreview';
import { SelectInput } from 'Shared/form/SelectField';

const PaddedRow = styled(Row)`
    padding: 0.5% 0;
`;

const propTypes = {
    onClose: PropTypes.func.isRequired,
};

const defaultProps = {};

const OneTimeTextMessageModal = ({ onClose }) => {
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [requestCallBack, setRequestCallBack] = useState(false);
    const { isLoading, data = [] } = useGetCustomMenuQuery('patient_messaging_one_time_templates');

    const preview = useCreateMesssagePreview(selectedTemplate?.value, requestCallBack);

    const message = preview.completeMessage;

    return (
        <Modal data-testid="onetimemessagemodelModal" show backdrop="static" size="lg">
            <Modal.Header closeButton={false}>
                <Modal.Title role="heading" className="header">
                    One-Time Text Message
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PaddedRow>
                    <Col md={6}>
                        <FormGroup>
                            <FormLabel className="field-required" htmlFor="selectMessage">
                                Select Message
                            </FormLabel>
                            <SelectInput
                                isLoading={isLoading}
                                name="selectMessage"
                                options={data}
                                onChange={(option) => {
                                    setSelectedTemplate(option);
                                }}
                                value={selectedTemplate}
                            />
                        </FormGroup>
                    </Col>
                    {selectedTemplate && (
                        <>
                            <Col md={12} style={{ paddingTop: '20px' }}>
                                <MessagePreview message={message} />
                            </Col>
                            <Col md={12} style={{ paddingTop: '20px' }}>
                                <CheckboxInput
                                    name="callbackRequestCheckbox"
                                    label="Include callback request"
                                    value={requestCallBack}
                                    onChange={(event) => setRequestCallBack(event.target.checked)}
                                />
                            </Col>
                        </>
                    )}
                </PaddedRow>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="outline-secondary"
                    data-testid="onetime-cancel-button"
                    name="cancel"
                    className="float-right"
                    onClick={() => {
                        onClose();
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    name="send"
                    className="float-right"
                    disabled={!selectedTemplate}
                    onClick={() => {
                        onClose({
                            ...selectedTemplate,
                            preview,
                        });
                    }}
                >
                    Send
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

OneTimeTextMessageModal.propTypes = propTypes;
OneTimeTextMessageModal.defaultProps = defaultProps;

export default OneTimeTextMessageModal;
